import React from "react";
import { useLocation } from "react-router-dom";

const Test = () => {
  const location: any = useLocation();
  const { schedule } = location.state;

  return (
    <>
      <div className="container">
        <h3 className="text-start mt-3">
          รายงาน {schedule.type === "tqf" ? "มคอ." : "อชว."} ประจำปีการศึกษา{" "}
          {schedule.year} เทอม {schedule.term}
        </h3>
        <div className="row mt-3">
          <div className="col">
            <h3 className="p-3 mb-4 bg-light rounded-4">
              <div className="row">
                <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ค้นหา"
                    aria-label="ค้นหา"
                  />
                </div>
                {/* <div className="col-2 d-grid">
                  <button type="button" className="btn btn-success text-white">
                    <i className="bi bi-folder-plus"></i> เพิ่ม
                  </button>
                </div> */}
              </div>
            </h3>
            <h5 className="text-start mt-3">รายการหลักสูตร {"type"} ทั้งหมด</h5>
            <table className="table table-hover table-responsive">
              <thead className="table-dark">
                <tr>
                  <th>ปีการศึกษา</th>
                  <th>ภาคการศึกษา</th>
                  <th>ประเภทเอกสาร</th>
                  <th>กำหนดส่ง 1</th>
                  <th>กำหนดส่ง 2</th>
                  <th>สถานะ</th>
                  <th>Handle</th>
                </tr>
              </thead>
              <tbody>
                {schedule.map((schedule: any) => {
                  return (
                    <tr key={schedule.id}>
                      <th scope="row">{schedule.year}</th>
                      <td>{schedule.term}</td>
                      <td>{schedule.type === "tqf" ? "มคอ." : "อชว."}</td>
                      <td>
                        {/* {moment(schedule.doc3)
                          .add(543, "year")
                          .format("DD/MM/yyyy")} */}
                      </td>
                      <td>
                        {/* {moment(schedule.doc5)
                          .add(543, "year")
                          .format("DD/MM/yyyy")} */}
                      </td>
                      <td>{schedule.status ? "เปิด" : "ไม่เปิด"}รับเอกสาร</td>
                      <td>
                        {/* <Link
                          to={{
                            pathname: Path.REPORT_CRRRI,
                            state: { schedule },
                          }}
                          type="button"
                          // className="btn btn-sm btn-outline-warning"
                          className="btn btn-sm btn-warning"
                        >
                          <i className="bi bi-file-earmark-text-fill"></i>{" "}
                          รายงานการส่งเอกสาร
                        </Link>{" "} */}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Test;
